<script setup>
defineProps({ modelValue: [String, Number], type: { type: String, default: "text" }, placeholder: String, readonly: Boolean })
const emit = defineEmits(["update:modelValue"])
</script>

<template>
  <input
    :type="type"
    class="input"
    :placeholder="placeholder"
    :readonly="readonly"
    :value="modelValue"
    @input="emit('update:modelValue', $event.target.value)"
  />
</template>
